// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content002_wrapper__NfeA5","more":"Content002_more__mVUJ6","loader":"Content002_loader__6XBTv","loader-wrapper":"Content002_loader-wrapper__Epb5Y"};